"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloaterWidget = exports.FloaterWidgetDefault = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Declarative_1 = require("../utils/Declarative");
var Geometry = require("../utils/Geometry");
var StackingComponent_1 = require("../utils/StackingComponent");
var ViewportHelpers = require("../utils/ViewportHelpers");
var Styles = {
    Floater: {
        position: 'absolute',
        outline: 0,
        pointerEvents: 'auto'
    }
};
var FloaterWidgetDefault = /** @class */ (function (_super) {
    tslib_1.__extends(FloaterWidgetDefault, _super);
    function FloaterWidgetDefault() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.floater = null;
        _this.centerTimeoutHandle = null;
        _this.state = { floaterElem: null };
        _this.floaterRefHandler = function (ref) {
            _this.floater = ref;
            _this.setState({ floaterElem: ref });
            if (!!_this.props.handleFloaterRef) {
                _this.props.handleFloaterRef(ref);
            }
        };
        return _this;
    }
    /** Gets a rect of the floater's size that is centered in the visual viewport. */
    FloaterWidgetDefault.prototype.getCenteredFloaterRectInLayoutCoords = function () {
        var viewportRectInLayoutCoords = ViewportHelpers.getVisualViewportRectRelativeToLayoutViewport();
        var floaterSize = { width: this.floater.offsetWidth, height: this.floater.offsetHeight };
        var centeredFloaterPosInLayoutCoords = Geometry.computePositionToCenterAreaInBounds(floaterSize, viewportRectInLayoutCoords);
        return Geometry.makeClientRect(centeredFloaterPosInLayoutCoords, floaterSize);
    };
    /** Gets a rect that represents a lower bound on the extents of the page. */
    FloaterWidgetDefault.prototype.getMinimumPageRectInLayoutCoords = function () {
        /**
         * It's tricky to get the full size of the page because super-wide elements can stretch the page beyond the document's
         * initial containing block, but getting a minimum bound on the page size is good enough for our purposes.
         */
        var pagePosInLayoutCoords = ViewportHelpers.getElementPositionRelativeToLayoutViewport(document.documentElement);
        var minimumPageSizeInferredFromLayoutViewport = ViewportHelpers.getLayoutViewportSize();
        var viewportRectInLayoutCoords = ViewportHelpers.getVisualViewportRectRelativeToLayoutViewport();
        var minimumPageSizeInferredFromVisualViewport = {
            width: viewportRectInLayoutCoords.right - pagePosInLayoutCoords.left,
            height: viewportRectInLayoutCoords.bottom - pagePosInLayoutCoords.top
        };
        var minimumPageSize = Geometry.getMaxWidthAndHeight(minimumPageSizeInferredFromLayoutViewport, minimumPageSizeInferredFromVisualViewport);
        return Geometry.makeClientRect(pagePosInLayoutCoords, minimumPageSize);
    };
    /**
     * Centers the floater in the visual viweport.
     */
    FloaterWidgetDefault.prototype.centerInVisualViewport = function () {
        var centeredFloaterRectInLayoutCoords = this.getCenteredFloaterRectInLayoutCoords();
        var minimumPageRectInLayoutCoords = this.getMinimumPageRectInLayoutCoords();
        /** Constrain position to prevent us from positioning outside of the page, which could cause unwanted overflow. */
        var constrainedFloaterPosInLayoutCoords = Geometry.computePositionToContainBounds(centeredFloaterRectInLayoutCoords, minimumPageRectInLayoutCoords);
        this.setPosition(constrainedFloaterPosInLayoutCoords);
    };
    FloaterWidgetDefault.prototype.getFloaterClientRect = function () {
        return this.floater.getBoundingClientRect();
    };
    /**
     * Set the position of the floater widget. The position should be in layout viewport coordinates.
     */
    FloaterWidgetDefault.prototype.setPosition = function (pos) {
        var offsetParent = this.floater.offsetParent || document.documentElement;
        var offsetParentPosInLayoutCoords = ViewportHelpers.getElementPositionRelativeToLayoutViewport(offsetParent);
        var posInOffsetParentCoords = Geometry.subtractPositions(pos, offsetParentPosInLayoutCoords);
        this.floater.style.top = posInOffsetParentCoords.top + 'px';
        this.floater.style.left = posInOffsetParentCoords.left + 'px';
    };
    FloaterWidgetDefault.prototype.componentDidMount = function () {
        this.centerInVisualViewport();
    };
    FloaterWidgetDefault.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        // only recenter for prop updates, not state updates
        if (this.props.shouldRecenterOnUpdate && prevState.floaterElem === this.state.floaterElem) {
            this.clearDeferredCentering();
            /* Positioning is size-sensitive, so make sure the DOM has been drawn first before positioning */
            this.centerTimeoutHandle = window.setTimeout(function () {
                _this.centerInVisualViewport();
            }, 0);
        }
    };
    FloaterWidgetDefault.prototype.clearDeferredCentering = function () {
        if (this.centerTimeoutHandle) {
            clearTimeout(this.centerTimeoutHandle);
            this.centerTimeoutHandle = null;
        }
    };
    FloaterWidgetDefault.prototype.componentWillUnmount = function () {
        this.clearDeferredCentering();
    };
    FloaterWidgetDefault.prototype.render = function () {
        return (React.createElement(StackingComponent_1.StackingRootContext.Provider, { value: this.state.floaterElem },
            React.createElement("div", { children: this.props.children, "data-tb-test-id": Declarative_1.makeTestId(this.props.testId, 'Floater'), ref: this.floaterRefHandler, style: tslib_1.__assign(tslib_1.__assign({}, Styles.Floater), this.props.customFloaterStyle) })));
    };
    return FloaterWidgetDefault;
}(React.Component));
exports.FloaterWidgetDefault = FloaterWidgetDefault;
exports.FloaterWidget = StackingComponent_1.StackingComponentHOC(FloaterWidgetDefault);
exports.FloaterWidget.displayName = 'FloaterWidget';
//# sourceMappingURL=FloaterWidget.js.map